const runValidation = (scope) => {
  if (!scope.inputElement)
    return;
  scope.inputElement.setCustomValidity('');
  scope.validationError = undefined;
  if (scope.isDisabled || scope.isReadonly) {
    // disabled or readonly is valid
    if (scope.dsForm)
      scope.dsForm.checkValidity();
    return;
  }
  scope.validationError = scope.validate ? scope.validate(scope.value) : undefined;
  if (scope.validationError) {
    scope.inputElement.setCustomValidity(scope.validationError);
  }
  else if (scope.injectedError) {
    scope.inputElement.setCustomValidity(scope.injectedError);
  }
  if (scope.dsForm)
    scope.dsForm.checkValidity();
};
const validateElementContainer = (container) => {
  for (let i = 0; i < container.elements.length; i++) {
    const element = container.elements[i];
    if (element.disabled || element.readonly)
      continue;
    if (!element.validity.valid)
      return false;
  }
  return true;
};

export { runValidation as r, validateElementContainer as v };
